<template>
  <div>
    <AdminTableContainer
      :users="localUsers"
      :headers="headers"
      :options="options" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AdminTableContainer from '../../components/AdminTableContainer'

export default {
  name: 'DietitianClients',
  components: { AdminTableContainer },
  data() {
    return {
      headers: ['name', 'parents', 'email', 'phone'],
      localUsers: {},
      options: {
        sortable: true,
        actions: ['accountMgmt']
      }
    }
  },
  methods: {
    ...mapActions(['getClients'])
  },
  computed: {
    ...mapGetters(['users'])
  },
  mounted: async function() {
    await this.getClients({})
    this.localUsers = this.users
  },
  watch: {
    users: {
      handler: function () {
        this.localUsers = this.users
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/DietitianMgmt/DietitianClients.vue?7c3841d8